import { getCurrentConfig } from "@certa/queries/hooks/config.hook";
import { invalidateUserQuery } from "@certa/queries/hooks/authV2.hooks";
import { onlyUpdateUserInfo as reduxOnlyUpdateUserInfo } from "main/src/modules/LoginPage/loginSlice";
import { store } from "main/src/js/_helpers/store";
import { get as lodashGet } from "lodash-es";

// TODO: Remove once migrated to new auth flow
export const isNewAuthFlow = (): boolean => {
  const config = getCurrentConfig();
  return lodashGet(config, "feature_toggles.ENABLE_NEW_AUTH_FLOW", true);
};

/**
 * Direct authentication actions that can be called outside React components
 */
export const directAuthActions = {
  /**
   * Mainly used after impersonation ends
   */
  onlyUpdateUserInfo: async (): Promise<void> => {
    if (isNewAuthFlow()) {
      console.debug(
        "🚀 DirectAuthActions: Using new flow - refetching user data"
      );
      try {
        await invalidateUserQuery();

        console.debug("🚀 DirectAuthActions: User data updated successfully");
      } catch (error) {
        console.error(
          "🚀 DirectAuthActions: Failed to update user data:",
          error
        );
        // Don't throw - this should be non-blocking
      }
    } else {
      console.debug(
        "🔄 DirectAuthActions: Using legacy flow - dispatching onlyUpdateUserInfo"
      );
      store.dispatch(reduxOnlyUpdateUserInfo());
    }
  }
};
